import Rathinaboopathi from "./team photos/RATHINA BOOPATHI.jpg";
import Aruveen from "./team photos/ARUVEEN.jpeg";
import Praveen from "./team photos/PRAVEEN.jpg";
import Dhanuja from "./team photos/DHANUJA.jpg";
import Sakthi from "./team photos/JAYA SHAKTHI ADHAVAN.jpg";
import Mahaveersachin from "./team photos/MAHAVEER SACHIN.jpg";
import Periasamy from "./team photos/PERIASAMY.jpg";
import Ganapriya from "./team photos/GANAPRIYA.jpg";
import Akshaya from "./team photos/AKSHAYA.jpg";
import Akhil from "./team photos/AKHIL.jpg";
import Sakthiharish from "./team photos/SAKTHI HARISH.jpg";
import Saravana from "./team photos/SARAVANA.jpg";
import Sujitha from "./team photos/SUJITHA.jpg";
import Vishnujanani from "./team photos/VISHNUJANANI.jpg";
import Rakesh from "./team photos/RAKESH.jpg";
import Nithish from "./team photos/NITHISH.jpg";
import Abi from "./team photos/ABI.jpg";
import Vikram from "./team photos/VIKRAM.jpg";
import Parimala from "./team photos/PARIMALA MAM.jpg";
import Periyasamy from "./team photos/PERIYASAMY SIR.jpg";
import Surendran from "./team photos/SURENDRAN SIR.jpg";
import Yassir from "./team photos/YASSIR.jpg";

import doyouknow from "./Posters/do you know.jpeg";
import boa from "./Posters/BOA.jpeg";
import bocu from "./Posters/BOCU.jpeg";
import boe from "./Posters/BOE.jpeg";
import borp from "./Posters/BORP.jpeg";
import frame from "./Posters/frame.png";
import tech_expo from './Posters/tech-expo.jpg'
import quiz from  './Posters/quiz.png'
import cwu from "./Posters/CWU.jpeg";
import fluidic_fun from "./Posters/fluidic_fun.jpeg";
import sixth_gen from "./Posters/sixth_gen.jpeg";
import hotspots from "./Posters/hotspots.jpeg"
import dynamo from "./Posters/dynamo.jpeg";

const Data = {
  team: [
    {
      Name: "Tmt. S. Parimala Murugaveni",
      Position: "Club Advisor",
      Portfolio: "Associate Professor, Mechanical Engineering",
      image: Parimala,
    },
    {
      Name: "Dr. S. Periyasamy",
      Position: "Club Advisor",
      Portfolio: "Associate Professor, Mechanical Engineering",
      image: Periyasamy,
    },
    {
      Name: "Thiru. R. Surendran",
      Position: "Club Advisor",
      Portfolio: "Assistant Professor, Mechanical Engineering",
      image: Surendran,
    },
    {
      Name: "Aruveen T",
      Position: "Mentor",
      Portfolio: "Batch'22, Production Engineering",
      LinkedIn: "https://www.linkedin.com/in/aruveenavril",
      Github: "https://github.com/ARUVEENAVRIL",
      image: Aruveen,
    },
    {
      Name: "Periasamy K",
      Position: "Mentor",
      Portfolio: "Batch'22, Mechanical Engineering",
      LinkedIn: "https://www.linkedin.com/in/periasamy-k-857866176",
      Instgram:
        "https://www.instagram.com/p/B-eVjXXlrtr-18o3iLskl6o39PGSGmSO7N_oZY0/",
      image: Periasamy,
    },
    {
      Name: "Praveen V",
      Position: "President",
      Portfolio: "Final Year, Mechanical Engineering",
      Instgram: "https://www.instagram.com/praveen_pradheip/",
      image: Praveen,
    },
    {
      Name: "Mahaveer Sachin M",
      Position: "Vice President",
      Portfolio: "Final Year, Mechanical Engineering",
      Instgram: "https://instagram.com/_ms2603_?utm_medium=copy_link",
      LinkedIn: "https://www.linkedin.com/in/mahaveer-sachin-m-376677193",
      image: Mahaveersachin,
    },
    {
      Name: "Nithish Kumar S",
      Position: "Secretary",
      Portfolio: "Final Year, Mechanical Engineering",
      Instgram: "https://instagram.com/sea_.king_?utm_medium=copy_link",
      LinkedIn: "https://www.linkedin.com/in/nithish-kumar-s-968b231bb",
      image: Nithish,
    },
    {
      Name: "Sujitha B",
      Position: "Treasurer",
      Portfolio: "Final Year, Civil Engineering",
      Github: "https://github.com/SujithaBalamurugan",
      LinkedIn: "https://www.linkedin.com/in/sujitha-balamurugan-6091501b2",
      image: Sujitha,
    },

    {
      Name: "Saravana Kumar S",
      Position: "Project pilot",
      Portfolio: "Final Year, Mechanical Engineering",
      Instgram: "https://www.instagram.com/stunningsaravana10428/",
      LinkedIn: "https://www.linkedin.com/in/saravana-kumar-s-30b410203",
      image: Saravana,
    },
    {
      Name: "Mohamed Yassir",
      Position: "Manufacturing pilot",
      Portfolio: "Final Year, Mechanical Engineering",
      image: Yassir,
    },
    {
      Name: "Sakthi Harish M",
      Position: "Manufacturing pilot",
      Portfolio: "Final Year, Mechanical Engineering",
      LinkedIn: "https://www.linkedin.com/in/sakthi-harish-a36901211",
      image: Sakthiharish,
    },
    {
      Name: "Rakesh M J",
      Position: "Manufacturing pilot",
      Portfolio: "Final Year, Mechanical Engineering",
      LinkedIn: "https://www.linkedin.com/in/rakesh-m-j-606742222",
      image: Rakesh,
    },
    {
      Name: "Pon Abishega Rajan B",
      Position: "Design pilot",
      Portfolio: "Final Year, Mechanical Engineering",
      Instgram: "https://www.instagram.com/_ig_abi/",
      LinkedIn: "https://www.linkedin.com/in/pon-abishega-rajan-b-6137b4209/",
      image: Abi,
    },
    {
      Name: "Akhil L",
      Position: "Design pilot",
      Portfolio: "Final Year, Mechanical Engineering",
      Instgram: "https://instagram.com/akhil.lj?utm_medium=copy_link",
      LinkedIn: "https://www.linkedin.com/in/akhil-lj-2b5154234",
      image: Akhil,
    },
    {
      Name: "Vikram P",
      Position: "Electronics Pilot",
      Portfolio: "Final Year, Electronics and Communication Engineering",
      Instgram: "https://www.instagram.com/single_star_vikram_001/",
      LinkedIn: "https://www.linkedin.com/in/vikram-p-8aa01b17b",
      image: Vikram,
    },
    {
      Name: "Dhanuja A",
      Position: "Electronics Pilot",
      Portfolio: "Final Year, Electronics and Communication Engineering",
      Instgram: "https://www.instagram.com/_dhanu_anbu_19",
      LinkedIn: "https://www.linkedin.com/in/dhanuja-anbarasu-8058261b0",
      image: Dhanuja,
    },
    {
      Name: "Jaya Sakthi Adhavan",
      Position: "Electronics Pilot",
      Portfolio: "Final Year, Electrical and Electronics Engineering",
      Instgram: "https://instagram.com/jsadhavan?utm_medium=copy_link",
      LinkedIn: "https://www.linkedin.com/in/jaya-shakthi-adhavan-s-929aa51b2",
      image: Sakthi,
    },
    {
      Name: "Ganapriya S",
      Position: "Electronics & Programming Pilot",
      Portfolio: "Final Year, Computer Science Engineering",
      Instgram: "https://www.instagram.com/priya_kheersagar/",
      LinkedIn: "https://www.linkedin.com/in/ganapriyas/",
      Github: "https://github.com/ganapriyas",
      image: Ganapriya,
    },
    {
      Name: "Akshaya Raj S A",
      Position: "Electronics & Programming Pilot",
      Portfolio: "Final Year, Computer Science Engineering",
      Instgram: "https://www.instagram.com/akshaya_artfantasy/",
      LinkedIn: "https://www.linkedin.com/in/student-entrepreneur-4736b0211/",
      Github: "https://github.com/student-entrepreneur",
      image: Akshaya,
    },
    {
      Name: "Vishnujanani R",
      Position: "Editorial Pilot",
      Portfolio: "Final Year, Civil Engineering",
      Instgram: "https://instagram.com/vishnujanani._.73?utm_medium=copy_link",
      LinkedIn: "https://www.linkedin.com/in/vishnujanani-r-b1a37b1b3",
      image: Vishnujanani,
    },
    {
      Name: "Rathina Boopathi S",
      Position: "Web Pilot",
      Portfolio: "Final Year, Civil Engineering",
      Instgram: "https://www.instagram.com/_iam.srb_/",
      LinkedIn: "https://www.linkedin.com/in/rathinaboopathi-srb/",
      Github: "https://github.com/boopathi-srb",
      image: Rathinaboopathi,
    },
  ],

  events: [
    {
      Eventname: "Hence Quizified",
      Description: "An Online event to  impart and enhance your  insight in aviation via answering the quiz in Instagram story",
      Poster: quiz,
      Insta:
        "https://www.instagram.com/casgct",
      LinkedIn:
        "",
    },
    {
      Eventname: "Tech Expo - 2022",
      Description: "An event for all the clubs in GCT to show their work",
      Poster: tech_expo,
      Insta:
        "https://www.instagram.com/p/Cddsyz9pDJd/?utm_source=ig_web_copy_link",
      LinkedIn:
        "https://www.linkedin.com/posts/centaurus-aerospace-society-gct_technology-tech-technologydevelopment-activity-6930554996157554688-JKp2?utm_source=linkedin_share&utm_medium=android_app",
    },
    {
      Eventname: "Do you know?",
      Description:
        "An offline event to talk about drone tech with students of GCT.",
      Poster: doyouknow,
      Insta:
        "https://www.instagram.com/p/CcmMCdFJuZe/?utm_source=ig_web_copy_link",
      LinkedIn: "",
    },
    
   
  ],

  seminars: [
    {
      Eventname: "Dynamo",
      Description: "A seminar on Turbines",
      Speaker: "Bharath Kumar R",
      SpeakerPosition: "Active Member, Mechanical('24)",
      Speaker1: "",
      Speaker1Position: "",
      Poster: dynamo,
      Insta: "",
      LinkedIn: "",
    },
    {
      Eventname: "Hotspots",
      Description: "A seminar on Life of Stars and Sun spot",
      Speaker: "Monissha M",
      SpeakerPosition: "Active Member, IBT('24)",
      Speaker1: "",
      Speaker1Position: "",
      Poster: hotspots,
      Insta: "https://www.instagram.com/p/CiPuKsWpjlC/?igshid=NjQxMzA2Mjk=",
      LinkedIn: "",
    },
    {
      Eventname: "Sixth Gen",
      Description: "A seminar on Artificial Intelligence",
      Speaker: "Akshaya Raj S A",
      SpeakerPosition: "Electronics and programming pilot",
      Speaker1: "",
      Speaker1Position: "",
      Poster: sixth_gen,
      Insta: "https://www.instagram.com/p/CiFfaFxLIbQ/?igshid=NjQxMzA2Mjk=",
      LinkedIn: "",
    },
    {
      Eventname: "Fluidic Fun",
      Description: "A seminar on Fluid Mechanics",
      Speaker: "Rakesh M J",
      SpeakerPosition: "Manufacturing pilot",
      Speaker1: "Sakthi Harish M",
      Speaker1Position: "Manufacturing pilot",
      Poster: fluidic_fun,
      Insta: "https://www.instagram.com/p/Chwrn2rr3EF/?igshid=NjQxMzA2Mjk=",
      LinkedIn: "",
    },
    {
      Eventname: "Cosmos Within Us",
      Description: "A seminar on Cosmic perception",
      Speaker: "Praveen V",
      SpeakerPosition: "President",
      Speaker1: "Saravana Kumar S",
      Speaker1Position: "Project Pilot",
      Poster: cwu,
      Insta: "https://www.instagram.com/p/ChOobz1piE8/?utm_source=ig_web_copy_link",
      LinkedIn: "",
    },
    {
      Eventname: "Design of Drone Frame",
      Description: "A seminar on frame design",
      Speaker: "",
      SpeakerPosition: "",
      Speaker1: "Mahaveer Sachin M",
      Speaker1Position: "Vice President",
      Poster: frame,
      Insta: "https://www.instagram.com/p/Cdk_D1GPOfs/?igshid=MDJmNzVkMjY=",
      LinkedIn: "",
    },
    {
      Eventname: "Basics of Rocket Propulsion",
      Description: "A seminar on Rocket Propulsion",
      Speaker: "Praveen V",
      SpeakerPosition: "President",
      Speaker1: "Mahaveer Sachin M",
      Speaker1Position: "Vice President",
      Poster: borp,
      Insta:
        "https://www.instagram.com/p/CdD2OFoJDI6/?utm_source=ig_web_copy_link",
      LinkedIn: "",
    },
    {
      Eventname: "Basics of Electronics",
      Description: "A seminar on Electronics used in UAVs",
      Speaker: "Vikram P",
      SpeakerPosition: "Electronics Pilot",
      Speaker1: "Dhanuja A",
      Speaker1Position: "Electronics Pilot",
      Poster: boe,
      Insta:
        "https://www.instagram.com/p/Cc0k3PxpbNH/?utm_source=ig_web_copy_link",
      LinkedIn:
        "https://www.linkedin.com/feed/update/urn:li:activity:6924895190692372480",
    },
    {
      Eventname: "Basics of Coding on UAV",
      Description: "A seminar on coding on UAV",
      Speaker: "Ganapriya S",
      SpeakerPosition: "Electronics and Programming Pilot",
      Speaker1: "Akshaya Raj S A",
      Speaker1Position: "Electronics and Programming Pilot",
      Poster: bocu,
      Insta:
        "https://www.instagram.com/p/CcHpsfOpEj4/?utm_source=ig_web_copy_link",
      LinkedIn:
        "https://www.linkedin.com/feed/update/urn:li:activity:6922205590878388224",
    },
    {
      Eventname: "Basics of Aerodynamics",
      Description: "A seminar on Aerodynamics",
      Speaker: "Periasamy K",
      SpeakerPosition: " CAS Mentor",
      Speaker1: "",
      Speaker1Position: "",
      Poster: boa,
      Insta:
        "https://www.instagram.com/p/CcCEyTYJ8Y7/?utm_source=ig_web_copy_link",
      LinkedIn:
        "https://www.linkedin.com/feed/update/urn:li:activity:6917700806527918080",
    },
    
  ],
};

export default Data;
